import { Fragment } from 'react';
import { Link } from 'react-router-dom-v5-compat';
import { IconButton } from '@material-ui/core';
import IconClose from '@material-ui/icons/esm/Close';
import cx from 'classnames';
import PropTypes from 'prop-types';

import ImageHand from 'src/assets/img/dd-banner.png';
import { CUSTOM_BUTTON_COLOR, CustomButton } from 'src/components/CustomButton';
import { CustomTypography, TYPOGRAPHY_VARIANT } from 'src/components/CustomTypography';
import { UPGRADE_ORIGIN } from 'src/data/common';
import { SUBSCRIPTION_PLAN } from 'src/data/subscription';
import * as events from 'src/lib/events';
import { formatDataDrivenCheckoutLink } from 'src/lib/routing';

import { useStyles } from './useStyles';

const UPGRADE_URL = formatDataDrivenCheckoutLink();

export const DDUpgradePanel = ({ className, onUpgrade, onClose, inlineDocument }) => {
  const styles = useStyles();

  const handleUpgradeClicked = (event) => {
    event.stopPropagation();

    events.trackCrmEvent(events.CRM_EVENT.clickedUpgradeButton, {
      cta: events.CRM_SUBSCRIPTION_ACTION.buyNow,
      origin: UPGRADE_ORIGIN.scoringPopup,
      plan: events.convertSubscriptionPlanForCrm(SUBSCRIPTION_PLAN.dataDriven),
    });
    onUpgrade();
  };

  const handleCloseClick = (event) => {
    event.stopPropagation();
    onClose();
  };

  return (
    <div className={cx(className, styles.root)}>
      <IconButton
        className={styles.buttonClose}
        onClick={handleCloseClick}
      >
        <IconClose />
      </IconButton>
      <img
        className={styles.bannerImage}
        src={ImageHand}
        alt=""
      />
      <CustomTypography
        className={styles.title}
        variant={TYPOGRAPHY_VARIANT.paragraph14}
      >
        {inlineDocument ? (
          <b>Let Anyword optimize your copy and boost your score</b>
        ) : (
          <Fragment>
            <b>Your perfect copy. Step-by-step.</b>
            <br />
            Get real-time scoring and analytics for every edit you make.
          </Fragment>
        )}
      </CustomTypography>

      <CustomButton
        className={styles.button}
        component={Link}
        to={UPGRADE_URL}
        onClick={handleUpgradeClicked}
        target="_blank"
        color={CUSTOM_BUTTON_COLOR.upsell}
      >
        Upgrade to Data-Driven plan
      </CustomButton>
    </div>
  );
};

DDUpgradePanel.propTypes = {
  className: PropTypes.string,
  onUpgrade: PropTypes.func,
  onClose: PropTypes.func,
  inlineDocument: PropTypes.bool,
};
DDUpgradePanel.defaultProps = {
  className: null,
  onUpgrade: null,
  onClose: null,
  inlineDocument: false,
};
